import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { SockGame } from "./components/SockGame";

const Home = () => {
  return (
    <div className="min-h-screen bg-[#FDF8F5] flex flex-col items-center justify-center p-4" data-testid="home-page">
      <header className="mb-6 text-center">
        <h1 className="font-fredoka text-4xl sm:text-5xl font-bold text-[#1E1E1E] mb-2">
          The Lost Sock
        </h1>
        <p className="font-nunito text-base sm:text-lg text-[#957DAD]">
          A sock's journey through chaos
        </p>
      </header>
      
      <main className="w-full flex justify-center">
        <SockGame />
      </main>
      
      <footer className="mt-6 text-center">
        <p className="font-nunito text-sm text-[#957DAD]">
          Made with 💜 | Tap to jump, avoid obstacles!
        </p>
      </footer>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
